import { useTranslation } from "react-i18next";
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { useAuthority } from "../../../controllers/AuthorityController"
import { Button, Form, Input, Typography, Radio, Row, Col, ProTableOt, useProTableOt, Select, message } from "../../../../ui/ot"
import { useEffect, useRef, useState } from "react"
import { useCRUDController } from "./../../../../ui/classify_structure/CRUDController";
// import AddMARC from "../AddMARC";
import MARCFormItems from './../marc_form_items'
const SearchAuthority = ({
    rowKey = 'authid',
    keyPrefix = 'library.authority.searchAuthority'

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef()
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [modalOpen, setModalOpen] = useState(false);
    const Columns = [//Summary	Heading type	Used in	
        {
            title: t(`Summary`),
            dataIndex: 'code_value',
            key: 'code_value',
        },
        {
            title: t(`Heading_type`),
            dataIndex: 'authtypetext',
            key: 'authtypetext',
        },
        {
            title: t(`Used_in`),
            dataIndex: 'linked_count',
            key: 'linked_count',
        },
        // {
        //     title: t(`Actions`),
        //     dataIndex: 'Actions',
        //     key: 'Actions',
        //     render: (text, record, index) => {
        //         console.log("actions", text, record, index)
        //         return (
        //             <CardView
        //                 card={<>
        //                     <Typography.P>{record?.author}</Typography.P>
        //                     <Typography.P><span style={{ fontWeight: 'bold' }}>{record?.title}</span>{record?.edition}&nbsp;{record?.publisher}</Typography.P>
        //                 </>}
        //                 marc={record?.marcstring}
        //                 record={record}
        //             >
        //             </CardView>
        //         )
        //     }
        // },
    ]
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[rowKey]
                );
                selectRow = selectRow.filter(
                    (row) => row?.[rowKey] !== record?.[rowKey]
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        Columns
    })

    const {
        getAuthorityData
    } = useAuthority({
        onBefore: () => { },
        onFinish: () => { }
    })
    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reload();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));

                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            // setModalLoading(false);
            setModalOpen(false);
        }
    };
    const authorityController = useCRUDController({
        apiRoute: "/koha/authority",
        onFinish: onFinish
    });

    return (
        <Row>
            <Col
                span={24}
            >
                <MainContainer>
                    <Typography.Title level={3}>
                        {t('')}
                    </Typography.Title>
                    <FlexBox>
                        <WhiteBox>
                            <Form form={form}>
                                <Row>
                                    <Col span={24}>
                                        <Form.Item
                                            name="scope"
                                            label={t(`Scope`)}
                                        >
                                            <Radio.Group className="flex flex-row">
                                                <Radio value={"mainHeadingA"}>
                                                    {t(`mainHeadingA`)}
                                                </Radio>
                                                <Radio value={"mainHeading"}>
                                                    {t(`mainHeading`)}
                                                </Radio>
                                                <Radio value={"allHeading"}>
                                                    {t(`allHeading`)}
                                                </Radio>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name="keyword"
                                            label={t(`Keyword`)}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>

                        </WhiteBox>
                    </FlexBox>
                    <ButtonGroup>
                        <Button onClick={() => { actionRef.current.reloadAndRest() }}>{t("search")}</Button>
                        <Button variant="ghost" onClick={() => navigate('/library/backstage/Cataloging')}>{t("cancel")}</Button>
                    </ButtonGroup>
                </MainContainer>
            </Col>
            <Col
                span={24}
            >
                <ProTableOt
                    rowKey={rowKey}
                    actionRef={actionRef}
                    columns={Columns}
                    request={async (params = {}, sort, filter) => {
                        // setAxiosMode("get")
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        const aFormValues = Object.entries(form.getValues());
                        aFormValues.forEach(([key, value]) => {
                            newParams[key] = value
                        })
                        // setPageSize(params?.pageSize ?? 20)
                        return authorityController.getData({
                            ...newParams
                        })
                    }}
                    // rowSelection={false}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys,
                        setSelectedRowsInfo,
                        ...rowSelection,
                    }}
                    PropsPatchForm={<AuthorityForm />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,

                                    }
                                })
                                authorityController.postData(newData)
                            },
                            // patchData: authorityController.patchData,
                            patchData: (data) => {

                                let newData = data?.map((val) => {
                                    return {
                                        ...val,

                                    }
                                })
                                authorityController.patchData(newData)
                            },
                            deleteData: (data) => {
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                authorityController.deleteData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={true}
                    propsPatchProcess={(record) => {
                        console.log({
                            record
                        })
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={true}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost
                    propsPostOnBefore
                    initialValues={{}}
                    propsWidth={1800}
                // extraActionRender={(record) => {
                //     return <Row gutter={[8, 8]} wrap={false}>
                //         <Col>
                //             <Button disabled={!!record?.received_date} size={"small"} >
                //                 確認接收
                //             </Button>
                //         </Col>
                //     </Row>
                // }}


                />


            </Col>
        </Row >

    )
}

const AuthorityForm = (
    {
        keyPrefix = 'library.authority.searchAuthority',
        propsForm,
        field,
        initialValues,
        defaultValue,
        onFormFinish = () => { },
        propsOnValuesChange = () => { }

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const { t } = useTranslation('translation', { keyPrefix })
    const [count, setCount] = useState(0)
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        values.collection_code = values.collection_code === "0" ? null : values.collection_code
        values.shelving_control_number = values.shelving_control_number ?? null
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        propsOnValuesChange(value)
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        formValues = form.getFieldsValue();
        form.setFieldsValue({ ...formValues, ...defaultValue })
    }, [defaultValue])

    return (
        <Row>
            <Col span={24}
            >
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={(value) => {

                    }}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                MARCDefaultValue={getAnyFormValue([field?.name ?? '', 'metadata'].filter((ele) => !!ele).join('.'))}
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                            />
                        </Col>
                    </Row>
                </Form>

            </Col>
        </Row>
    );

}
const FormItemComponent = ({
    keyPrefix,
    field,
    MARCDefaultValue = null,
    initialValues = {},
    transferInLibraryOptions,
    transferOutLibraryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const kohaAuthorityTypeController = useCRUDController({ apiRoute: "/koha/authority/type" })
    useEffect(() => {
        kohaAuthorityTypeController.getData({})
    }, [])

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Row>
                    <Col>
                        <Form.Item
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'authid']}
                            fieldKey={[field?.id ?? '', 'authid'].filter((ele) => !!ele).join('.')}
                        >
                            <div></div>
                        </Form.Item>
                    </Col>

                </Row>
            </Col>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label={t('authority_type')}
                            labelCol={4}
                            wrapperCol={20}
                            {...field}
                            name={[field?.name ?? '', 'authtypecode']}
                            fieldKey={[field?.id ?? '', 'authtypecode'].join('.')}
                            rules={[{ required: true, message: '請選擇' }]}
                        >
                            <Select
                                options={(kohaAuthorityTypeController?.ResponseData || []).map((value) => {
                                    return {
                                        label: value?.authtypetext,
                                        value: value?.authtypecode
                                    }
                                })}>
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
            </Col>


            <Col span={24}>
                <Form.Item
                    name={[field?.name ?? '', 'metadata']}
                >
                    <MARCFormItems
                        defaultValue={MARCDefaultValue}
                        name={[field?.name ?? '', 'metadata'].filter((ele) => !!ele).join('.')}

                    />
                </Form.Item>
            </Col>
        </Row>
    );
};
const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const Em20 = styled.div`
width: 20em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const FlexBox = styled.div`
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 1em;
`

const VerticalFlexBox = styled.div`
display: flex;
flex-direction: column;
flex-wrap: nowrap;
align-items: flex-start;
justify-content: flex-start;
gap: 1em;
`

const ContextBox = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
justify-content: center;
gap: 1em;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
`

export default SearchAuthority